export interface ISerialPortModel {
  name: string
}

export class SerialPortModel implements ISerialPortModel {
  name: string

  constructor(data: ISerialPortModel) {
    this.name = data.name;
  }
}